import PolicyLayout from './PolicyLayout';
import { ADDRESS, BRAND, COMPANY_NAME, SITE_DOMAIN } from '../constants/site';

export default function Disclaimer() {
  return (
    <PolicyLayout
      title="Disclaimer"
      updated="1 August 2026"
      showDisclaimer={false}
      intro={`The information on this website is published in good faith and for general guidance only. This page explains the limits of what we claim, our relationship to the software publishers we support, and what you should independently verify.`}
    >
      <h2>Independent Service Provider</h2>
      <p>
        {SITE_DOMAIN} is operated by <strong>{COMPANY_NAME}</strong>, {ADDRESS}, an independent
        reseller and third-party technical support provider. We are <strong>not</strong> affiliated
        with, endorsed by, sponsored by, or in any way officially connected to {BRAND}, LLC, or any
        of its subsidiaries or affiliates. Official support channels are available directly from the
        software publisher through their own website.
      </p>

      <h2>Trademarks</h2>
      <p>
        {BRAND} and the {BRAND} logo are registered trademarks of {BRAND}, LLC. All other product
        names, company names, logos, and brands appearing on this website are the property of their
        respective owners. Their use here is purely descriptive — to identify the products we resell
        and support — and does not imply any endorsement, partnership, or authorisation.
      </p>

      <h2>No Guarantee of Absolute Security</h2>
      <p>
        No antivirus product, including the ones we sell, can guarantee protection against every
        threat. New malware appears constantly, and effectiveness depends on keeping software
        updated, using strong passwords, and exercising caution online. Statements about protection
        levels describe intended functionality, not a guaranteed outcome.
      </p>

      <h2>Accuracy of Information</h2>
      <p>
        We make every effort to keep pricing, feature lists, and system requirements accurate and
        current. However, software publishers change specifications and pricing without notice. We
        do not warrant that all content on this website is complete, current, or free from error,
        and we reserve the right to correct any inaccuracy at any time.
      </p>

      <h2>Pricing Disclaimer</h2>
      <p>
        Advertised prices reflect promotional first-term rates and may be limited by time, quantity,
        or region. Renewal pricing differs from introductory pricing. Taxes and fees may apply
        depending on your location. The price confirmed at the point of checkout is the price that
        applies to your order.
      </p>

      <h2>Not Professional Advice</h2>
      <p>
        Articles, guides, and security tips published on this website are general information, not
        professional legal, financial, or cybersecurity consulting advice. For a formal security
        assessment of a business network, engage a qualified consultant who can review your specific
        environment.
      </p>

      <h2>External Links</h2>
      <p>
        This website may contain links to external sites that are not operated by us. We have no
        control over the content, privacy practices, or availability of those sites and accept no
        responsibility for them. Visiting a linked site is at your own discretion.
      </p>

      <h2>Limitation of Liability</h2>
      <p>
        Under no circumstances shall {COMPANY_NAME} be liable for any loss or damage of any kind
        incurred as a result of using this website or relying on information published here. Your
        use of this website and any reliance you place on its content is solely at your own risk.
      </p>

      <h2>Consent</h2>
      <p>
        By continuing to use this website, you consent to this disclaimer and agree to its terms. If
        you do not agree with any part of it, please discontinue use of the site.
      </p>
    </PolicyLayout>
  );
}
